import React, { Component } from 'react';
import './quickTransferCard.less';
import { ArrowDownDefault, CryptoLogo, FinanceLogo, MonestoLogoShort, SwapVertical, Transfer, UnifyLogo } from 'IMAGE';
import { fieldChange, fieldValidation } from 'FIELDS';
import getFormData from 'get-form-data';
import SelectSet from '@molecules/form/items-sets/SelectSet';
import { InputsSet, RadioSet } from 'INPUTS';
import { Button, Dropdown, Form } from 'antd';
import axios from 'axios';
import api from 'API';
import notification from '@helps/notification';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import merge from 'deepmerge';

// HOC для подключения к Redux в классовом компоненте
const withRedux = (Component) => {
  return (props) => {
    const configs = merge(require('ROOT/configs.json'), require('ROOT/configs.prod.json'), {
      arrayMerge: (target, source) => [...new Set([...target, ...source])],
    });
    const specialUsers = configs.variables.magma_and_monesto_users;
    const userIds = useSelector((state) => state.personal.customers_ids);
    const isDoubleAccountMagmaMonesto = useSelector((state) => state.personal.doubleAccountMagmaMonesto);
    const isRubTransferEnabled = useSelector((state) => state.personal.rubTransferEnabled);

    const isSpecialUser = specialUsers?.some((item) => userIds.includes(item)) || isDoubleAccountMagmaMonesto;

    return <Component {...props} isSpecialUser={isSpecialUser} isRubTransferEnabled={isRubTransferEnabled} />;
  };
};

class QuickTransferCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type_from: {
        customService: true,
        twoChoice: true,
        name: 'type_from',
        value: 'FIAT',
        label: false,
        keys: [
          {
            title: 'MAGMA',
            value: 'FIAT',
          },
          {
            title: 'FINARIUM',
            value: 'CRYPTO',
          },
          {
            title: 'LAVA',
            value: 'INVESTMENTS',
          },
        ],
      },
      type_to: {
        customService: true,
        twoChoice: true,
        name: 'type_to',
        value: 'CRYPTO',
        label: false,
        keys: [
          {
            title: 'MAGMA',
            value: 'FIAT',
          },
          {
            title: 'FINARIUM',
            value: 'CRYPTO',
          },
          {
            title: 'LAVA',
            value: 'INVESTMENTS',
          },
        ],
      },
      amount: {
        name: 'amount',
        required: true,
        placeholder: true,
        // min: 0,
        type: 'number',
        // validation: {
        //   isDisableNumber: {
        //     error: 'nullValue',
        //   },
        //   length: true,
        // },
        // disabled: props.disabled,
      },
      currency: {
        customCurrency: true,
        name: 'currency',
        keys: this.getCurrencyKeys(),
        required: true,
        disableSearch: true,
        label: 'Currency',
        // disabled: props.disabled,
      },
      wallet_id_from: {
        customWallet: true,
        name: 'wallet_id_from',
        keys: [],
        amount: null,
        required: true,
        disableSearch: true,
        label: 'Wallet',
        service: null,
      },
      wallet_id_to: {
        customWallet: true,
        name: 'wallet_id_to',
        keys: [],
        required: true,
        disableSearch: true,
        label: 'Wallet',
        service: null,
      },
      isDropdownOpenFrom: false,
      isDropdownOpenTo: false,
      wallets_fiat: [],
      wallets_monesto: [],
      wallets_crypto: [],
      wallets_investments: [],
      isLoading: false,
    };

    this._mounted = false;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this, this);
    this.handleSwap = this.handleSwap.bind(this);
    this.handleMaxAmount = this.handleMaxAmount.bind(this);
    this.fieldValidation = fieldValidation.bind(this, this);
  }

  getCurrencyKeys = () => {
    const baseKeys = [
      {
        title: 'USD',
        value: 'USD',
      },
      {
        title: 'EUR',
        value: 'EUR',
      },
    ];

    // Если RUB разрешен, добавляем его
    if (this.props.isRubTransferEnabled) {
      baseKeys.push({
        title: 'RUB',
        value: 'RUB',
      });
    }

    return baseKeys;
  };

  // Функция для получения ключей в зависимости от isSpecialUser и monestoToken
  getKeys = () => {
    const baseKeys = [
      {
        title: 'FINARIUM',
        value: 'CRYPTO',
      },
      {
        title: 'LAVA',
        value: 'INVESTMENTS',
      },
    ];

    if (this.props.isSpecialUser) {
      // Для специальных пользователей: MAGMA + MONESTO (если есть токен) + FINARIUM + LAVA
      const magmaKey = {
        title: 'MAGMA',
        value: 'FIAT',
      };

      const monestoKey = this.props.monestoToken
        ? {
            title: 'MONESTO',
            value: 'MONESTO',
          }
        : null;

      // Собираем все доступные ключи, фильтруя null
      return [magmaKey, monestoKey, ...baseKeys].filter((key) => key !== null);
    } else {
      // Для обычных пользователей: MAGMA или MONESTO (в зависимости от токена) + FINARIUM + LAVA
      const mainKey = this.props.monestoToken
        ? {
            title: 'MONESTO',
            value: 'MONESTO',
          }
        : {
            title: 'MAGMA',
            value: 'FIAT',
          };

      return [mainKey, ...baseKeys];
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.disabled !== this.props.disabled ||
      prevProps.monestoToken !== this.props.monestoToken ||
      prevProps.isSpecialUser !== this.props.isSpecialUser ||
      prevProps.isRubTransferEnabled !== this.props.isRubTransferEnabled
    ) {
      // Определяем начальное значение для type_from
      let initialTypeValue = 'FIAT';
      if (this.props.isSpecialUser) {
        initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
      } else {
        initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
      }

      this.setState({
        amount: {
          ...this.state.amount,
          disabled: this.props.disabled,
        },
        currency: {
          ...this.state.currency,
          keys: this.getCurrencyKeys(),
          disabled: this.props.disabled,
        },
        type_from: {
          ...this.state.type_from,
          value: initialTypeValue,
          keys: this.getKeys(),
        },
        type_to: {
          ...this.state.type_to,
          value: 'CRYPTO',
          keys: this.getKeys(),
        },
      });
      this.getWallets();
    }
  }

  componentDidMount() {
    // Определяем начальное значение для type_from
    let initialTypeValue = 'FIAT';
    if (this.props.isSpecialUser) {
      initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
    } else {
      initialTypeValue = this.props.monestoToken ? 'MONESTO' : 'FIAT';
    }

    this.setState(
      {
        currency: {
          ...this.state.currency,
          keys: this.getCurrencyKeys(),
          disabled: this.props.disabled,
        },
        type_from: {
          ...this.state.type_from,
          value: initialTypeValue,
          keys: this.getKeys(),
        },
        type_to: {
          ...this.state.type_to,
          keys: this.getKeys(),
        },
      },
      () => {
        this.getWallets().then(() => {
          // После загрузки кошельков, автоматически выбираем первый для type_from
          this.autoSelectWalletFrom();
          this.autoSelectWalletTo();
        });
      }
    );
  }

  processServerResponse(response) {
    if (response) {
      const updates = {};

      if (response.magma) {
        updates.wallets_fiat = Object.values(response.magma).map((wallet) => ({ ...wallet }));
      }

      if (response.monesto) {
        updates.wallets_monesto = Object.values(response.monesto).map((wallet) => ({ ...wallet }));
      }

      if (response.finarium) {
        updates.wallets_crypto = Object.values(response.finarium).map((wallet) => ({ ...wallet }));
      }

      if (response.lava) {
        updates.wallets_investments = Object.values(response.lava).map((wallet) => ({ ...wallet }));
      }

      if (Object.keys(updates).length > 0) {
        this.setState(updates);
      }
    }
  }

  async getWallets() {
    try {
      const result = await axios(api.users.wallets().AXIOS('GET'));
      this.processServerResponse(result.data);
      return result.data; // Возвращаем данные для возможности использования в Promise
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  // handleFieldChange(context, item) {
  //   fieldChange(context, item);
  //
  //   if (item.name === 'currency') {
  //     this.setState((prevState) => ({
  //       wallet_id_from: {
  //         ...prevState.wallet_id_from,
  //         value: null,
  //         keys: [],
  //       },
  //       wallet_id_to: {
  //         ...prevState.wallet_id_to,
  //         value: null,
  //         keys: [],
  //       },
  //     }));
  //
  //     if (item.value === 'USDT' || item.value === 'USDC') {
  //       // Для USDT/USDC показываем только FINARIUM и LAVA
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           value: 'CRYPTO',
  //           keys: [
  //             {
  //               title: 'FINARIUM',
  //               value: 'CRYPTO',
  //             },
  //             {
  //               title: 'LAVA',
  //               value: 'INVESTMENTS',
  //             },
  //           ],
  //         },
  //         type_to: {
  //           ...prevState.type_to,
  //           value: 'INVESTMENTS',
  //           keys: [
  //             {
  //               title: 'FINARIUM',
  //               value: 'CRYPTO',
  //             },
  //             {
  //               title: 'LAVA',
  //               value: 'INVESTMENTS',
  //             },
  //           ],
  //         },
  //       }));
  //     } else {
  //       // Для остальных валют используем getKeys()
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           keys: this.getKeys(),
  //         },
  //         type_to: {
  //           ...prevState.type_to,
  //           keys: this.getKeys(),
  //         },
  //       }));
  //     }
  //   }
  //
  //   if (item.name === 'type_from') {
  //     // Проверяем, не совпадает ли новое значение type_from с type_to
  //     if (item.value === this.state.type_to.value) {
  //       // Если совпадает, сбрасываем type_from в null
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           value: null,
  //         },
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           value: null,
  //           keys: [],
  //         },
  //       }));
  //
  //       // Показываем уведомление пользователю
  //       notification('From and To cannot be the same. Please select a different source.', 'info');
  //       return;
  //     }
  //
  //     this.setState((prevState) => ({
  //       wallet_id_from: {
  //         ...prevState.wallet_id_from,
  //         value: null,
  //         keys: [],
  //       },
  //     }));
  //
  //     if (item.value === 'FIAT') {
  //       const walletsKeys = this.state.wallets_fiat.map((wallet) => ({
  //         title: wallet.iban,
  //         value: wallet.iban,
  //         amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //         currency: this.state.currency.value,
  //       }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_to: {
  //           ...prevState.type_to,
  //           value: 'CRYPTO',
  //         },
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //
  //     if (item.value === 'MONESTO') {
  //       const walletsKeys = this.state.wallets_monesto.map((wallet) => ({
  //         title: wallet.iban,
  //         value: wallet.iban,
  //         amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //         currency: this.state.currency.value,
  //       }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_to: {
  //           ...prevState.type_to,
  //           value: 'CRYPTO',
  //         },
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //
  //     if (item.value === 'CRYPTO') {
  //       const walletsKeys = this.state.wallets_crypto.map((wallet) => ({
  //         title: wallet.iban,
  //         value: wallet.iban,
  //         amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //         currency: this.state.currency.value,
  //       }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_to: {
  //           ...prevState.type_to,
  //           value: 'INVESTMENTS',
  //         },
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //
  //     if (item.value === 'INVESTMENTS') {
  //       const walletsKeys = this.state.wallets_investments
  //         .filter((wallet) => wallet.balance.some((el) => el.currency === this.state.currency.value))
  //         .map((wallet) => ({
  //           title: wallet.iban,
  //           value: wallet.iban,
  //           amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //           currency: this.state.currency.value,
  //         }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_to: {
  //           ...prevState.type_to,
  //           value: 'CRYPTO',
  //         },
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //   }
  //
  //   if (item.name === 'type_to') {
  //     // Проверяем, не совпадает ли новое значение type_to с type_from
  //     if (item.value === this.state.type_from.value) {
  //       // Если совпадает, сбрасываем type_from в null (а не type_to)
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           value: null,
  //         },
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           value: null,
  //           keys: [],
  //         },
  //       }));
  //
  //       // Показываем уведомление пользователю
  //       notification('From and To cannot be the same. Please select a different source.', 'info');
  //       return;
  //     }
  //
  //     this.setState((prevState) => ({
  //       wallet_id_to: {
  //         ...prevState.wallet_id_to,
  //         value: null,
  //         keys: [],
  //       },
  //     }));
  //
  //     if (item.value === 'FIAT') {
  //       const walletsKeys = this.state.wallets_fiat.map((wallet) => ({
  //         title: wallet.iban,
  //         value: wallet.iban,
  //         amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //         currency: this.state.currency.value,
  //       }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           value: 'CRYPTO',
  //         },
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //
  //     if (item.value === 'MONESTO') {
  //       const walletsKeys = this.state.wallets_monesto.map((wallet) => ({
  //         title: wallet.iban,
  //         value: wallet.iban,
  //         amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //         currency: this.state.currency.value,
  //       }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           value: 'CRYPTO',
  //         },
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //
  //     if (item.value === 'CRYPTO') {
  //       const walletsKeys = this.state.wallets_crypto.map((wallet) => ({
  //         title: wallet.iban,
  //         value: wallet.iban,
  //         amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //         currency: this.state.currency.value,
  //       }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           value: 'INVESTMENTS',
  //         },
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //
  //     if (item.value === 'INVESTMENTS') {
  //       const walletsKeys = this.state.wallets_investments
  //         .filter((wallet) => wallet.balance.some((el) => el.currency === this.state.currency.value))
  //         .map((wallet) => ({
  //           title: wallet.iban,
  //           value: wallet.iban,
  //           amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
  //           currency: this.state.currency.value,
  //         }));
  //
  //       this.setState((prevState) => ({
  //         wallet_id_to: {
  //           ...prevState.wallet_id_to,
  //           keys: walletsKeys,
  //         },
  //       }));
  //
  //       this.setState((prevState) => ({
  //         type_from: {
  //           ...prevState.type_from,
  //           value: 'CRYPTO',
  //         },
  //         wallet_id_from: {
  //           ...prevState.wallet_id_from,
  //           keys: walletsKeys,
  //           value: null,
  //         },
  //       }));
  //     }
  //   }
  // }

  // Метод для автоматического выбора кошелька FROM
  autoSelectWalletFrom = () => {
    const { type_from, currency } = this.state;

    if (!type_from.value || !currency.value) return;

    let walletsKeys = [];

    if (type_from.value === 'FIAT') {
      walletsKeys = this.state.wallets_fiat.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));
    } else if (type_from.value === 'MONESTO') {
      walletsKeys = this.state.wallets_monesto.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));
    } else if (type_from.value === 'CRYPTO') {
      walletsKeys = this.state.wallets_crypto.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));
    } else if (type_from.value === 'INVESTMENTS') {
      walletsKeys = this.state.wallets_investments
        .filter((wallet) => wallet.balance.some((el) => el.currency === currency.value))
        .map((wallet) => ({
          title: wallet.iban,
          value: wallet.iban,
          amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
          currency: currency.value,
        }));
    }

    // Обновляем keys и автоматически выбираем первый кошелек, если он только один
    this.setState((prevState) => ({
      wallet_id_from: {
        ...prevState.wallet_id_from,
        keys: walletsKeys,
        value: walletsKeys.length === 1 ? walletsKeys[0].value : null,
      },
    }));
  };

  // Метод для автоматического выбора кошелька TO
  autoSelectWalletTo = () => {
    const { type_to, currency } = this.state;

    if (!type_to.value || !currency.value) return;

    let walletsKeys = [];

    if (type_to.value === 'FIAT') {
      walletsKeys = this.state.wallets_fiat.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));
    } else if (type_to.value === 'MONESTO') {
      walletsKeys = this.state.wallets_monesto.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));
    } else if (type_to.value === 'CRYPTO') {
      walletsKeys = this.state.wallets_crypto.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));
    } else if (type_to.value === 'INVESTMENTS') {
      walletsKeys = this.state.wallets_investments
        .filter((wallet) => wallet.balance.some((el) => el.currency === currency.value))
        .map((wallet) => ({
          title: wallet.iban,
          value: wallet.iban,
          amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
          currency: currency.value,
        }));
    }

    // Обновляем keys и автоматически выбираем первый кошелек, если он только один
    this.setState((prevState) => ({
      wallet_id_to: {
        ...prevState.wallet_id_to,
        keys: walletsKeys,
        value: walletsKeys.length === 1 ? walletsKeys[0].value : null,
      },
    }));
  };

  handleFieldChange(context, item) {
    // Если это выбор wallet_id_from и значение выбрано (не null)
    if (item.name === 'wallet_id_from' && item.value) {
      setTimeout(() => {
        this.setState({ isDropdownOpenFrom: false });
      }, 100);
    }

    // Если это выбор wallet_id_to и значение выбрано (не null)
    if (item.name === 'wallet_id_to' && item.value) {
      setTimeout(() => {
        this.setState({ isDropdownOpenTo: false });
      }, 100);
    }

    fieldChange(context, item);

    if (item.name === 'currency') {
      this.setState((prevState) => ({
        wallet_id_from: {
          ...prevState.wallet_id_from,
          value: null,
          keys: [],
        },
        wallet_id_to: {
          ...prevState.wallet_id_to,
          value: null,
          keys: [],
        },
      }));

      if (item.value === 'USDT' || item.value === 'USDC') {
        // Для USDT/USDC показываем только FINARIUM и LAVA
        this.setState(
          (prevState) => ({
            type_from: {
              ...prevState.type_from,
              value: 'CRYPTO',
              keys: [
                {
                  title: 'FINARIUM',
                  value: 'CRYPTO',
                },
                {
                  title: 'LAVA',
                  value: 'INVESTMENTS',
                },
              ],
            },
            type_to: {
              ...prevState.type_to,
              value: 'INVESTMENTS',
              keys: [
                {
                  title: 'FINARIUM',
                  value: 'CRYPTO',
                },
                {
                  title: 'LAVA',
                  value: 'INVESTMENTS',
                },
              ],
            },
          }),
          () => {
            // После обновления типов, автоматически выбираем кошельки
            setTimeout(() => {
              this.autoSelectWalletFrom();
              this.autoSelectWalletTo();
            }, 100);
          }
        );
      } else {
        // Для остальных валют используем getKeys()
        this.setState(
          (prevState) => ({
            type_from: {
              ...prevState.type_from,
              keys: this.getKeys(),
            },
            type_to: {
              ...prevState.type_to,
              keys: this.getKeys(),
            },
          }),
          () => {
            // После обновления типов, автоматически выбираем кошельки
            setTimeout(() => {
              this.autoSelectWalletFrom();
              this.autoSelectWalletTo();
            }, 100);
          }
        );
      }
    }

    if (item.name === 'type_from') {
      // Проверяем, не совпадает ли новое значение type_from с type_to
      if (item.value === this.state.type_to.value) {
        // Если совпадает, сбрасываем type_from в null
        this.setState((prevState) => ({
          type_from: {
            ...prevState.type_from,
            value: null,
          },
          wallet_id_from: {
            ...prevState.wallet_id_from,
            value: null,
            keys: [],
          },
        }));

        notification('From and To cannot be the same. Please select a different source.', 'info');
        return;
      }

      this.setState(
        (prevState) => ({
          wallet_id_from: {
            ...prevState.wallet_id_from,
            value: null,
            keys: [],
          },
        }),
        () => {
          // После сброса, автоматически выбираем кошелек
          setTimeout(() => {
            this.autoSelectWalletFrom();
          }, 100);
        }
      );
    }

    if (item.name === 'type_to') {
      // Проверяем, не совпадает ли новое значение type_to с type_from
      if (item.value === this.state.type_from.value) {
        // Если совпадает, сбрасываем type_from в null (а не type_to)
        this.setState((prevState) => ({
          type_from: {
            ...prevState.type_from,
            value: null,
          },
          wallet_id_from: {
            ...prevState.wallet_id_from,
            value: null,
            keys: [],
          },
        }));

        notification('From and To cannot be the same. Please select a different source.', 'info');
        return;
      }

      this.setState(
        (prevState) => ({
          wallet_id_to: {
            ...prevState.wallet_id_to,
            value: null,
            keys: [],
          },
        }),
        () => {
          // После сброса, автоматически выбираем кошелек
          setTimeout(() => {
            this.autoSelectWalletTo();
          }, 100);
        }
      );
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.fieldValidation()) {
      return;
    }

    let rawData = getFormData(event.target, { trim: true });
    const data = this.normalizeFormData(rawData);
    // Проверка на null значения
    if (!data.type_from || !data.type_to || !data.wallet_id_from || !data.wallet_id_to) {
      notification('Please select all required fields', 'error');
      return;
    }

    const amountFrom = this.getAmountFrom();

    if (amountFrom < data.amount) {
      notification('Insufficient funds for transfer', 'error');
      return;
    }

    const requestData = {
      from: {
        space:
          data.type_from[0] === 'FIAT'
            ? 'magma'
            : data.type_from[0] === 'MONESTO'
            ? 'monesto'
            : data.type_from[0] === 'CRYPTO'
            ? 'finarium'
            : 'lava',
        wallet: data.wallet_id_from[0],
      },

      to: {
        space:
          data.type_to[0] === 'FIAT'
            ? 'magma'
            : data.type_to[0] === 'MONESTO'
            ? 'monesto'
            : data.type_to[0] === 'CRYPTO'
            ? 'finarium'
            : 'lava',
        wallet: data.wallet_id_to[0],
      },

      amount: data.amount,
      currency: data.currency,
    };

    // Дополнительная проверка перед отправкой
    if (requestData.from.space === requestData.to.space) {
      notification('From and To cannot be the same space', 'error');
      return;
    }

    try {
      this.setState({ isLoading: true });
      const result = await axios(api.users.transfer().AXIOS('POST', requestData));

      this.props.onUpdateBalance();
      this.getWallets();
      this.updateFromWallet();
      notification('Transfer completed successfully', 'success');
    } catch (e) {
      if (e.response?.data?.message) {
        notification(e.response?.data?.message, 'error');
      }
    } finally {
      this.setState({ isLoading: false });
    }
  }

  normalizeFormData = (data) => {
    const normalized = {};

    Object.keys(data).forEach((key) => {
      if (key === 'wallet_id_from' || key === 'wallet_id_to') {
        // Приводим wallet_id к массиву
        normalized[key] = Array.isArray(data[key]) ? data[key] : [data[key]];
      } else if (key === 'type_from' || key === 'type_to') {
        // type_from и type_to тоже могут быть строками
        normalized[key] = Array.isArray(data[key]) ? data[key] : [data[key]];
      } else {
        normalized[key] = data[key];
      }
    });

    return normalized;
  };

  updateFromWallet() {
    const { type_from, currency } = this.state;

    if (type_from.value === 'FIAT') {
      const walletsKeys = this.state.wallets_fiat.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));

      this.setState((prevState) => ({
        wallet_id_from: {
          ...prevState.wallet_id_from,
          keys: walletsKeys,
        },
      }));
    }

    if (type_from.value === 'MONESTO') {
      const walletsKeys = this.state.wallets_monesto.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));

      this.setState((prevState) => ({
        wallet_id_from: {
          ...prevState.wallet_id_from,
          keys: walletsKeys,
        },
      }));
    }

    if (type_from.value === 'CRYPTO') {
      const walletsKeys = this.state.wallets_crypto.map((wallet) => ({
        title: wallet.iban,
        value: wallet.iban,
        amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
        currency: currency.value,
      }));

      this.setState((prevState) => ({
        wallet_id_from: {
          ...prevState.wallet_id_from,
          keys: walletsKeys,
        },
      }));
    }

    if (type_from.value === 'INVESTMENTS') {
      const walletsKeys = this.state.wallets_investments
        .filter((wallet) => wallet.balance.some((el) => el.currency === this.state.currency.value))
        .map((wallet) => ({
          title: wallet.iban,
          value: wallet.iban,
          amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
          currency: this.state.currency.value,
        }));

      this.setState((prevState) => ({
        wallet_id_from: {
          ...prevState.wallet_id_from,
          keys: walletsKeys,
        },
      }));
    }
  }

  handleVisibleChangeFrom = (visible) => {
    this.setState({ isDropdownOpenFrom: visible });

    if (visible) {
      this.updateFromWallet();
    }
  };

  handleVisibleChangeTo = (visible) => {
    this.setState({ isDropdownOpenTo: visible });

    const { type_to, currency } = this.state;

    if (visible) {
      if (type_to.value === 'FIAT') {
        const walletsKeys = this.state.wallets_fiat.map((wallet) => ({
          title: wallet.iban,
          value: wallet.iban,
          amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
          currency: currency.value,
        }));

        this.setState((prevState) => ({
          wallet_id_to: {
            ...prevState.wallet_id_to,
            keys: walletsKeys,
          },
        }));
      }

      if (type_to.value === 'MONESTO') {
        const walletsKeys = this.state.wallets_monesto.map((wallet) => ({
          title: wallet.iban,
          value: wallet.iban,
          amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
          currency: currency.value,
        }));

        this.setState((prevState) => ({
          wallet_id_to: {
            ...prevState.wallet_id_to,
            keys: walletsKeys,
          },
        }));
      }

      if (type_to.value === 'CRYPTO') {
        const walletsKeys = this.state.wallets_crypto.map((wallet) => ({
          title: wallet.iban,
          value: wallet.iban,
          amount: wallet.balance.find((el) => el.currency === currency.value)?.balance,
          currency: currency.value,
        }));

        this.setState((prevState) => ({
          wallet_id_to: {
            ...prevState.wallet_id_to,
            keys: walletsKeys,
          },
        }));
      }

      if (type_to.value === 'INVESTMENTS') {
        const walletsKeys = this.state.wallets_investments
          .filter((wallet) => wallet.balance.some((el) => el.currency === this.state.currency.value))
          .map((wallet) => ({
            title: wallet.iban,
            value: wallet.iban,
            amount: wallet.balance.find((el) => el.currency === this.state.currency.value)?.balance,
            currency: this.state.currency.value,
          }));

        this.setState((prevState) => ({
          wallet_id_to: {
            ...prevState.wallet_id_to,
            keys: walletsKeys,
          },
        }));
      }
    }
  };

  formatNumber(value) {
    const amount = Number(value).toFixed(2);
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  }

  getAmountFrom() {
    const {
      type_from,
      type_to,
      currency,
      wallets_fiat,
      wallets_monesto,
      wallets_crypto,
      wallets_investments,
      wallet_id_from,
      wallet_id_to,
    } = this.state;

    if (currency.value && type_from.value) {
      if (type_from.value === 'FIAT' && wallet_id_from.value) {
        return this.formatNumber(
          wallets_fiat
            .find((el) => el.iban === wallet_id_from.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }

      if (type_from.value === 'MONESTO' && wallet_id_from.value) {
        return this.formatNumber(
          wallets_monesto
            .find((el) => el.iban === wallet_id_from.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }

      if (type_from.value === 'CRYPTO' && wallet_id_from.value) {
        return this.formatNumber(
          wallets_crypto
            .find((el) => el.iban === wallet_id_from.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }

      if (type_from.value === 'INVESTMENTS' && wallet_id_from.value) {
        return this.formatNumber(
          wallets_investments
            .find((el) => el.iban === wallet_id_from.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }
    }

    return null;
  }

  getAmountTo() {
    const {
      type_from,
      type_to,
      currency,
      wallets_fiat,
      wallets_monesto,
      wallets_crypto,
      wallets_investments,
      wallet_id_from,
      wallet_id_to,
    } = this.state;

    if (currency.value && type_to.value) {
      if (type_to.value === 'FIAT' && wallet_id_to.value) {
        return this.formatNumber(
          wallets_fiat
            .find((el) => el.iban === wallet_id_to.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }

      if (type_to.value === 'MONESTO' && wallet_id_to.value) {
        return this.formatNumber(
          wallets_monesto
            .find((el) => el.iban === wallet_id_to.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }

      if (type_to.value === 'CRYPTO' && wallet_id_to.value) {
        return this.formatNumber(
          wallets_crypto
            .find((el) => el.iban === wallet_id_to.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }

      if (type_to.value === 'INVESTMENTS' && wallet_id_to.value) {
        return this.formatNumber(
          wallets_investments
            .find((el) => el.iban === wallet_id_to.value)
            ?.balance.find((el) => el.currency === currency.value)?.balance || 0
        );
      }
    }

    return null;
  }

  handleSwap() {
    this.setState((prevState) => ({
      wallet_id_to: { ...prevState.wallet_id_from, name: prevState.wallet_id_to.name },
      wallet_id_from: { ...prevState.wallet_id_to, name: prevState.wallet_id_from.name },
      type_from: { ...prevState.type_to, name: prevState.type_from.name },
      type_to: { ...prevState.type_from, name: prevState.type_to.name },
    }));
  }

  handleMaxAmount() {
    const { wallet_id_from } = this.state;
    if (wallet_id_from?.value) {
      this.setState((prevState) => ({
        amount: {
          ...prevState.amount,
          value: this.getAmountFrom(),
        },
      }));
    }
  }

  render() {
    const { isDropdownOpenFrom, isDropdownOpenTo, wallet_id_from, wallet_id_to, type_to, type_from, currency } =
      this.state;

    const waletToLabel = wallet_id_to.keys.find((el) => el.value === wallet_id_to.value)?.title;
    const waletFromLabel = wallet_id_from.keys.find((el) => el.value === wallet_id_from.value)?.title;

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <div className='quick-transfer' id='area'>
            <div className='quick-transfer__title'>
              <Transfer /> Club Transfer
            </div>

            <div className='quick-transfer__pair'>
              <span className='quick-transfer__subtitle'>Please select transfer currency</span>
              <div className='quick-transfer__currency'>{SelectSet(this, ['currency'])}</div>
            </div>

            <div style={{ display: 'none' }}>{RadioSet(this, ['type_from'])}</div>
            <div style={{ display: 'none' }}> {SelectSet(this, ['wallet_id_from'])} </div>

            <div style={{ display: 'none' }}>{RadioSet(this, ['type_to'])}</div>
            <div style={{ display: 'none' }}> {SelectSet(this, ['wallet_id_to'])} </div>
            <div className='quick-transfer__wallets'>
              <Dropdown
                className='dropdown-wallet'
                disabled={!currency.value}
                trigger={['click']}
                placement='topCenter'
                visible={isDropdownOpenFrom}
                onVisibleChange={this.handleVisibleChangeFrom}
                getPopupContainer={(trigger) => trigger.closest('#area') || document.body}
                overlay={
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className='overlay-block'
                  >
                    <div className='title'>{RadioSet(this, ['type_from'])}</div>

                    <div> {SelectSet(this, ['wallet_id_from'])} </div>
                  </div>
                }
              >
                <div className='quick-transfer__dropdown-block'>
                  <div className='title'>
                    <span className='label'>FROM</span>
                    <div>
                      {type_from.value === 'FIAT' && <FinanceLogo height={14} width={14} />}
                      {type_from.value === 'MONESTO' && <MonestoLogoShort height={14} width={14} />}
                      {type_from.value === 'CRYPTO' && <CryptoLogo height={14} width={14} />}
                      {type_from.value === 'INVESTMENTS' && <UnifyLogo height={14} width={14} />}

                      <span className='service'>
                        {type_from.value === 'FIAT' && 'MAGMA'}
                        {type_from.value === 'MONESTO' && 'MONESTO'}
                        {type_from.value === 'CRYPTO' && 'FINARIUM'}
                        {type_from.value === 'INVESTMENTS' && 'LAVA'}
                      </span>
                    </div>
                  </div>
                  <div className='main'>
                    <div className='name'>
                      <span className='label'>WALLET </span>
                      <span className='wallet'>{waletFromLabel}</span>
                    </div>
                    <ArrowDownDefault />
                  </div>
                  <div className='balance'>
                    <span className='label'>AVAILABLE</span>
                    <div className='amount'>{this.getAmountFrom()}</div>
                  </div>
                </div>
              </Dropdown>

              <div className='quick-transfer__swap' onClick={this.handleSwap}>
                <SwapVertical />
              </div>

              <Dropdown
                disabled={!currency.value}
                trigger={['click']}
                placement='topCenter'
                visible={isDropdownOpenTo}
                onVisibleChange={this.handleVisibleChangeTo}
                getPopupContainer={(trigger) => trigger.closest('#area') || document.body}
                overlay={
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className='overlay-block'
                  >
                    <div className='title'>{RadioSet(this, ['type_to'])}</div>

                    <div> {SelectSet(this, ['wallet_id_to'])} </div>
                  </div>
                }
              >
                <div className='quick-transfer__dropdown-block'>
                  <div className='title'>
                    <span className='label'>TO</span>
                    <div>
                      {type_to.value === 'FIAT' && <FinanceLogo height={14} width={14} />}
                      {type_to.value === 'MONESTO' && <MonestoLogoShort height={14} width={14} />}
                      {type_to.value === 'CRYPTO' && <CryptoLogo height={14} width={14} />}
                      {type_to.value === 'INVESTMENTS' && <UnifyLogo height={14} width={14} />}

                      <span className='service'>
                        {type_to.value === 'FIAT' && 'MAGMA'}
                        {type_to.value === 'MONESTO' && 'MONESTO'}
                        {type_to.value === 'CRYPTO' && 'FINARIUM'}
                        {type_to.value === 'INVESTMENTS' && 'LAVA'}
                      </span>
                    </div>
                  </div>
                  <div className='main'>
                    <div className='name'>
                      <span className='label'>WALLET </span>
                      <span className='wallet'>{waletToLabel}</span>
                    </div>
                    <ArrowDownDefault />
                  </div>
                  <div className='balance'>
                    <span className='label'>AVAILABLE</span>
                    <div className='amount'>{this.getAmountTo()}</div>
                  </div>
                </div>
              </Dropdown>

              <div className='amount-block'>
                <div className='quick-transfer__amount'>{InputsSet(this, ['amount'])}</div>
                <Button type='primary' onClick={this.handleMaxAmount} disabled={!wallet_id_from.value}>
                  MAX
                </Button>
              </div>
            </div>

            <Button
              htmlType={'submit'}
              type={'dashed'}
              size={'default'}
              block
              disabled={
                this.state.isLoading ||
                this.props.disabled ||
                !this.state.type_from.value || // Добавлено: дизейблим если type_from не выбран
                !this.state.type_to.value || // Добавлено: дизейблим если type_to не выбран
                (this.state.type_from.value === 'CRYPTO' && this.state.type_to.value === 'INVESTMENTS') ||
                (this.state.type_from.value === 'INVESTMENTS' && this.state.type_to.value === 'CRYPTO')
              }
            >
              <span className='btn-text'>TRANSFER MONEY</span>
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default withRedux(QuickTransferCard);

QuickTransferCard.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onUpdateBalance: PropTypes.func.isRequired,
  monestoToken: PropTypes.bool.isRequired,
  isSpecialUser: PropTypes.bool,
  isRubTransferEnabled: PropTypes.bool,
};
